import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const embed = {
  fetchInfoWidget: lazyModuleMethod(
    () => import('./fetchInfoWidget'),
    'default'
  ),
}
